// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gwL_36s26zUU5lwPmPgL {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  background: #f7f7f7;
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
}
.obN3YFDUFBVKq2X1TBYn {
  padding-top: 10px;
  height: calc(100vh - 44px);
  overflow: hidden;
}
.XbK5WeDINyS2QyfLj0zq {
  font-size: 16px;
  color: #fff;
  background-color: #79c9e3;
  padding: 10px 20px;
  text-align: center;
  height: 44px;
}
.s7oBpiMqWc8mUEl9i1g2 {
  margin-top: 10px;
}
/* 自定义 Tabs 样式 */
.A_sIGfyBmO23QNDucVfq .ant-tabs-nav {
  width: 100% !important;
  margin-bottom: 0px;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-nav-list {
  display: flex;
  width: 100%;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-tab {
  flex: 1;
  text-align: center;
  margin-right: 0 !important;
  border-radius: 4px 4px 0 0;
  background: #f5f5f5 !important;
  border: 1px solid #d9d9d9 !important;
  border-bottom: none !important;
  transition: all 0.3s;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-tab .ant-tabs-tab-btn {
  width: 100%;
  color: #666 !important;
  font-weight: 500;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-tab-active {
  background: linear-gradient(180deg, #79c9e3, #d9eff6) !important;
  border: none !important;
  box-shadow: none !important;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-tab:hover {
  background: linear-gradient(180deg, #5db9d8, #c4e7f2) !important;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-ink-bar {
  display: none !important;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-content-holder {
  padding: 0 !important;
}
.A_sIGfyBmO23QNDucVfq .ant-tabs-tabpane {
  background: #f7f7f7;
}
.IAxDA1BZ5TPLKS8bvzD_ {
  height: calc(100vh - 90px);
  overflow: auto;
}
.L9uiZ1O_4aL0LuCgohJw {
  padding: 10px;
  border-radius: 0 0 8px 8px;
  margin-bottom: 10px;
  background: #fff;
}
.trfRUMKwkEsoEBOUW80n {
  width: 100%;
  height: calc(100vh - 90px);
  border-radius: 0 0 8px 8px;
  margin-bottom: 10px;
  background: #fff;
}
.trfRUMKwkEsoEBOUW80n .ant-spin-tip {
  color: #666;
}
.MsISAq5Iu1BQxQkLTn0d {
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  background: #fff;
}
.xsUA8XwFNrtBlEUHxF7g {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 8px;
  background-color: #e8f4f8;
}
.XA4r2e4HlNgrIjCrBFmW {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #1a1a1a;
}
.chIP81EE8RII4Ti1GY_f {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}
.q4qWo7tRIP2JOwMHR2j8 {
  border: 0;
  border-top: 1px solid #e8e8e8;
  margin: 16px 0;
}
.LPr9m6y1XOZItM1oMzcA {
  margin-bottom: 16px;
}
.XGet3iMXj0inrP56iU1A {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #737373;
}
.hTDPKvhmgqLoeKmM2DPJ {
  font-weight: 500;
  color: #666;
  margin-right: 8px;
}
.G9NLV72Ui6HgyLEqiZ0c {
  margin-bottom: 24px;
}
.iwkHR64fiJF1Bq7c1TnY {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #1a1a1a;
}
.G9NLV72Ui6HgyLEqiZ0c p {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}
.rdrIudbR1foytG_1KbDt {
  display: flex;
  justify-content: space-around;
  gap: 80px;
}
.P67Pbu2qAgoxoTe755Ct {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.P67Pbu2qAgoxoTe755Ct img {
  width: 30px;
  height: 30px;
  margin-bottom: 8px;
}
.P67Pbu2qAgoxoTe755Ct p {
  font-size: 14px;
  color: #333;
  margin: 0;
}
.Hy1fX31IYOMJRN6mZSWV {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.t6CkAlHCz39Lkypg6_pL {
  max-width: 100%;
  border-radius: 4px;
}
.MreMBUEk6ultcTJYGRRq {
  margin-top: 16px;
}
/* 历史检查部分样式 */
.DxKFx6RLXkYyHID6p55c {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
  gap: 20px;
}
.DxKFx6RLXkYyHID6p55c:hover {
  background: #f0f0f0;
}
.aep_mDXcqjhGoUx3PFf6 {
  margin-right: 12px;
}
.aep_mDXcqjhGoUx3PFf6 img {
  width: 24px;
  height: 24px;
}
.Nn7JME_UjBj9A04Hx6Ig {
  flex: 1;
}
.Nn7JME_UjBj9A04Hx6Ig h3 {
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.4;
  margin-bottom: 10px;
}
.Nn7JME_UjBj9A04Hx6Ig p {
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}
.FKYW2JuEP2phXimzG378 {
  font-size: 16px;
  color: #666;
  font-weight: bold;
}
/* 免责声明部分样式 */
.dIBhgdZQNb1Z9vhI9g0G {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.dIBhgdZQNb1Z9vhI9g0G .PTrs1mDcm6kZ7Gq_kX7y {
  color: #333;
  font-weight: 600;
}
/* 第一个 Modal（分享设置）样式 */
.WmjJ1A_qy4wmjaC3J_MI {
  margin-top: 10px;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp {
  margin-bottom: 8px;
  padding: 10px 15px;
  border-radius: 4px;
  background-color: #f8f8f8;
  /* 自定义 Select 样式 */
  /* 自定义 Checkbox 样式 */
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .hTDPKvhmgqLoeKmM2DPJ {
  display: inline-block;
  width: 80px;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .TwKzEOliy5w6hSEDg2_h {
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 8px;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .dWUypglIC8T4iE0JK65B {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #d9d9d9 !important;
  height: 36px !important;
  display: flex;
  align-items: center;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .ant-select-selection-item {
  color: #333 !important;
  font-size: 14px !important;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .ant-checkbox-wrapper {
  font-size: 14px;
  color: #666;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .ant-checkbox-wrapper .ant-checkbox-inner {
  border-color: #d9d9d9 !important;
}
.WmjJ1A_qy4wmjaC3J_MI .DikjCWEiCDa25svx_SQp .ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #79c9e3 !important;
  border-color: #79c9e3 !important;
}
.WmjJ1A_qy4wmjaC3J_MI .wJrB6hEcmAgk7sssc02z {
  display: flex;
  gap: 50px;
}
.WmjJ1A_qy4wmjaC3J_MI .wJrB6hEcmAgk7sssc02z .Ygddb044TA0PMdIWD7Rg {
  margin-right: 50px;
}
.R5a8nVGXjuIUz7PY8suT {
  border-radius: 4px;
  background-color: #f8f8f8;
}
/* 第二个 Modal（链接分享）样式 */
._cRxsD9BnwaEuSDkudTB {
  margin-top: 30px;
}
._cRxsD9BnwaEuSDkudTB .OfG95PD4W7NWYlVvlq_D {
  padding: 10px 15px;
  border-radius: 4px;
  background-color: #f8f8f8;
}
._cRxsD9BnwaEuSDkudTB .OfG95PD4W7NWYlVvlq_D .hTDPKvhmgqLoeKmM2DPJ {
  width: 80px;
  font-weight: 500;
  color: #79c9e3;
  margin-right: 8px;
}
._cRxsD9BnwaEuSDkudTB .OfG95PD4W7NWYlVvlq_D .OkEAY7RTDxU9xtS_ZZqp {
  flex: 1;
  color: #333;
  font-size: 14px;
}
/* 第三个 Modal（影像下载须知）样式 */
.LUnxeDfm6tfYY1gA0BcE {
  margin-top: 20px;
}
.LUnxeDfm6tfYY1gA0BcE .K9KbCzzITdY8mJIO68yi {
  margin-bottom: 16px;
}
.LUnxeDfm6tfYY1gA0BcE .K9KbCzzITdY8mJIO68yi p {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 8px;
}
.LUnxeDfm6tfYY1gA0BcE .K9KbCzzITdY8mJIO68yi p span {
  font-size: 15px;
  color: #1a1a1a;
  font-weight: 600;
}
.LUnxeDfm6tfYY1gA0BcE .OfG95PD4W7NWYlVvlq_D {
  padding: 10px 15px;
}
.LUnxeDfm6tfYY1gA0BcE .OfG95PD4W7NWYlVvlq_D .hTDPKvhmgqLoeKmM2DPJ {
  width: 80px;
  font-weight: 500;
  color: #79c9e3;
  margin-right: 8px;
}
.LUnxeDfm6tfYY1gA0BcE .OfG95PD4W7NWYlVvlq_D .OkEAY7RTDxU9xtS_ZZqp {
  flex: 1;
  color: #333;
  font-size: 14px;
}
.BgaAzY5XvXXGWCxBnqI8 {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 0;
}
/* 自定义 Modal 通用样式 */
.ant-modal-header {
  text-align: center;
}
.ant-modal-header .ant-modal-title {
  font-size: 18px;
  font-weight: 500;
  color: #1a1a1a;
}
.ant-modal-footer {
  border-top: none !important;
  padding: 16px 0 !important;
  text-align: center;
  margin-top: 0;
}
.ant-modal-footer .ant-btn-primary {
  background-color: #79c9e3 !important;
  border-color: #79c9e3 !important;
  border-radius: 4px !important;
  color: #fff !important;
  transition: background-color 0.3s;
}
.ant-modal-footer .ant-btn-primary:hover {
  background-color: #5db9d8 !important;
  border-color: #5db9d8 !important;
}
.ant-modal-close-x {
  color: #666 !important;
}
.ant-modal-close-x:hover {
  color: #333 !important;
}
.ant-tabs-top > .ant-tabs-nav {
  margin-bottom: 0 !important;
}
.A_sIGfyBmO23QNDucVfq .nwJU2OYzMoxH8TnsilXe {
  display: block !important;
  visibility: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
}
.A_sIGfyBmO23QNDucVfq .rxNJ_89Crza76rEnnLJL {
  visibility: visible;
  position: relative;
}
.ant-modal .ant-modal-footer > .ant-btn + .ant-btn {
  margin-inline-start: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/PhoneReport/components/styles/reportDetail.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;AACF;AAEA;EACE,iBAAA;EACA,0BAAA;EACA,gBAAA;AAAF;AAGA;EACE,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AADF;AAIA;EACE,gBAAA;AAFF;AACA,gBAAgB;AAKhB;EAGM,sBAAA;EACA,kBAAA;AALN;AACA;EAQM,aAAA;EACA,WAAA;AANN;AAHA;EAaM,OAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;AAPN;AAbA;EAuBQ,WAAA;EACA,sBAAA;EACA,gBAAA;AAPR;AAlBA;EA8BM,gEAAA;EACA,uBAAA;EACA,2BAAA;AATN;AAvBA;EAoCM,gEAAA;AAVN;AA1BA;EAwCM,wBAAA;AAXN;AA7BA;EA4CM,qBAAA;AAZN;AAhCA;EAgDM,mBAAA;AAbN;AAkBA;EACE,0BAAA;EACA,cAAA;AAhBF;AAmBA;EACE,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;AAjBF;AAoBA;EACE,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;AAlBF;AAaA;EASM,WAAA;AAnBN;AAwBA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAtBF;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAvBF;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAxBF;AA2BA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAzBF;AA4BA;EACE,SAAA;EACA,6BAAA;EACA,cAAA;AA1BF;AA6BA;EACE,mBAAA;AA3BF;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AA5BF;AA+BA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AA7BF;AAgCA;EACE,mBAAA;AA9BF;AAiCA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA/BF;AAkCA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAhCF;AAmCA;EACE,aAAA;EACA,6BAAA;EACA,SAAA;AAjCF;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;AAqCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAnCF;AAsCA;EACE,eAAA;EACA,WAAA;EACA,SAAA;AApCF;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AArCF;AAwCA;EACE,eAAA;EACA,kBAAA;AAtCF;AAyCA;EACE,gBAAA;AAvCF;AACA,aAAa;AA0Cb;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;AAxCF;AA0CE;EACE,mBAAA;AAxCJ;AA4CA;EACE,kBAAA;AA1CF;AAyCA;EAII,WAAA;EACA,YAAA;AA1CJ;AA8CA;EACE,OAAA;AA5CF;AA2CA;EAII,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AA5CJ;AAmCA;EAaI,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;AA7CJ;AAiDA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AA/CF;AACA,aAAa;AAkDb;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAhDF;AA6CA;EAMI,WAAA;EACA,gBAAA;AAhDJ;AACA,sBAAsB;AAoDtB;EACE,gBAAA;AAlDF;AAiDA;EAII,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAlDF,kBAAkB;EAClB,oBAAoB;AACtB;AAyCA;EAUM,qBAAA;EACA,WAAA;AAhDN;AAqCA;EAeM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAjDN;AA+BA;EAsBM,eAAA;EACA,WAAA;EACA,gBAAA;AAlDN;AA0BA;EA8BQ,6BAAA;EACA,oCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AArDR;AAmBA;EAsCQ,sBAAA;EACA,0BAAA;AAtDR;AAeA;EA8CQ,eAAA;EACA,WAAA;AA1DR;AAWA;EAkDU,gCAAA;AA1DV;AAQA;EAsDU,oCAAA;EACA,gCAAA;AA3DV;AAIA;EA8DI,aAAA;EACA,SAAA;AA/DJ;AAAA;EAkEM,kBAAA;AA/DN;AAoEA;EACE,kBAAA;EACA,yBAAA;AAlEF;AACA,sBAAsB;AAqEtB;EACE,gBAAA;AAnEF;AAkEA;EAII,kBAAA;EACA,kBAAA;EACA,yBAAA;AAnEJ;AA6DA;EASM,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAnEN;AAuDA;EAgBM,OAAA;EACA,WAAA;EACA,eAAA;AApEN;AACA,wBAAwB;AAyExB;EACE,gBAAA;AAvEF;AAsEA;EAII,mBAAA;AAvEJ;AAmEA;EAOM,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAvEN;AA6DA;EAaQ,eAAA;EACA,cAAA;EACA,gBAAA;AAvER;AAwDA;EAqBI,kBAAA;AA1EJ;AAqDA;EAwBM,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA1EN;AA+CA;EA+BM,OAAA;EACA,WAAA;EACA,eAAA;AA3EN;AAgFA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA9EF;AACA,mBAAmB;AAiFnB;EAEI,kBAAA;AAhFJ;AA8EA;EAKM,eAAA;EACA,gBAAA;EACA,cAAA;AAhFN;AAyEA;EAYI,2BAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;AAlFJ;AAmEA;EAkBM,oCAAA;EACA,gCAAA;EACA,6BAAA;EACA,sBAAA;EACA,iCAAA;AAlFN;AAoFM;EACE,oCAAA;EACA,gCAAA;AAlFR;AAwDA;EAgCI,sBAAA;AArFJ;AAuFI;EACE,sBAAA;AArFN;AAkDA;EAwCI,2BAAA;AAvFJ;AA2FA;EAEI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AA1FJ;AAoFA;EAUI,mBAAA;EACA,kBAAA;AA3FJ;AA+FA;EAEI,iCAAA;AA9FJ","sourcesContent":[".containerWrap {\n  width: 100%;\n  min-height: 100vh;\n  overflow-y: auto;\n  background: #f7f7f7;\n  margin: 0 auto;\n  font-family: 'Arial', sans-serif;\n}\n\n.container {\n  padding-top: 10px;\n  height: calc(100vh - 44px);\n  overflow: hidden;\n}\n\n.title {\n  font-size: 16px;\n  color: #fff;\n  background-color: #79c9e3;\n  padding: 10px 20px;\n  text-align: center;\n  height: 44px;\n}\n\n.content {\n  margin-top: 10px;\n}\n\n/* 自定义 Tabs 样式 */\n.customTabs {\n  :global {\n    .ant-tabs-nav {\n      width: 100% !important;\n      margin-bottom: 0px;\n    }\n\n    .ant-tabs-nav-list {\n      display: flex;\n      width: 100%;\n    }\n\n    .ant-tabs-tab {\n      flex: 1;\n      text-align: center;\n      margin-right: 0 !important;\n      border-radius: 4px 4px 0 0;\n      background: #f5f5f5 !important;\n      border: 1px solid #d9d9d9 !important;\n      border-bottom: none !important;\n      transition: all 0.3s;\n\n      .ant-tabs-tab-btn {\n        width: 100%;\n        color: #666 !important;\n        font-weight: 500;\n      }\n    }\n\n    .ant-tabs-tab-active {\n      background: linear-gradient(180deg, #79c9e3, #d9eff6) !important;\n      border: none !important;\n      box-shadow: none !important;\n    }\n\n    .ant-tabs-tab:hover {\n      background: linear-gradient(180deg, #5db9d8, #c4e7f2) !important;\n    }\n\n    .ant-tabs-ink-bar {\n      display: none !important;\n    }\n\n    .ant-tabs-content-holder {\n      padding: 0 !important;\n    }\n\n    .ant-tabs-tabpane {\n      background: #f7f7f7;\n    }\n  }\n}\n\n.contentBoxMainWrap {\n  height: calc(100vh - 90px);\n  overflow: auto;\n}\n\n.contentBoxMain {\n  padding: 10px;\n  border-radius: 0 0 8px 8px;\n  margin-bottom: 10px;\n  background: #fff;\n}\n\n.viewerBoxMain {\n  width: 100%;\n  height: calc(100vh - 90px);\n  border-radius: 0 0 8px 8px;\n  margin-bottom: 10px;\n  background: #fff;\n\n  :global {\n    .ant-spin-tip {\n      color: #666;\n    }\n  }\n}\n\n.contentBox {\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  background: #fff;\n}\n\n.contentBoxTips {\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  background-color: #e8f4f8;\n}\n\n.reportTitle {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #1a1a1a;\n}\n\n.hospital {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 16px;\n}\n\n.divider {\n  border: 0;\n  border-top: 1px solid #e8e8e8;\n  margin: 16px 0;\n}\n\n.infoSection {\n  margin-bottom: 16px;\n}\n\n.infoItem {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #737373;\n}\n\n.label {\n  font-weight: 500;\n  color: #666;\n  margin-right: 8px;\n}\n\n.section {\n  margin-bottom: 24px;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #1a1a1a;\n}\n\n.section p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.actionButtons {\n  display: flex;\n  justify-content: space-around;\n  gap: 80px;\n}\n\n.actionItem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.actionItem img {\n  width: 30px;\n  height: 30px;\n  margin-bottom: 8px;\n}\n\n.actionItem p {\n  font-size: 14px;\n  color: #333;\n  margin: 0;\n}\n\n.filmPreview {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.filmImage {\n  max-width: 100%;\n  border-radius: 4px;\n}\n\n.downloadButton {\n  margin-top: 16px;\n}\n\n/* 历史检查部分样式 */\n.historySection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.3s;\n  gap: 20px;\n\n  &:hover {\n    background: #f0f0f0;\n  }\n}\n\n.historyIcon {\n  margin-right: 12px;\n\n  img {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.historyText {\n  flex: 1;\n\n  h3 {\n    font-size: 16px;\n    font-weight: 500;\n    color: #1a1a1a;\n    margin: 0;\n    line-height: 1.4;\n    margin-bottom: 10px;\n  }\n\n  p {\n    font-size: 12px;\n    color: #666;\n    margin: 0;\n    line-height: 1.4;\n  }\n}\n\n.historyArrow {\n  font-size: 16px;\n  color: #666;\n  font-weight: bold;\n}\n\n/* 免责声明部分样式 */\n.disclaimer {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.6;\n\n  .disclaimerTitle {\n    color: #333;\n    font-weight: 600;\n  }\n}\n\n/* 第一个 Modal（分享设置）样式 */\n.shareModalContent {\n  margin-top: 10px;\n\n  .shareModalItem {\n    margin-bottom: 8px;\n    padding: 10px 15px;\n    border-radius: 4px;\n    background-color: #f8f8f8;\n\n    .label {\n      display: inline-block;\n      width: 80px; // 固定宽度，确保对齐\n    }\n\n    .modalSubtitle {\n      font-size: 16px;\n      font-weight: 500;\n      color: #1a1a1a;\n      margin-bottom: 8px;\n    }\n\n    .modalDesc {\n      font-size: 14px;\n      color: #666;\n      line-height: 1.6;\n    }\n\n    /* 自定义 Select 样式 */\n    :global {\n      .ant-select-selector {\n        border-radius: 4px !important;\n        border: 1px solid #d9d9d9 !important;\n        height: 36px !important;\n        display: flex;\n        align-items: center;\n      }\n\n      .ant-select-selection-item {\n        color: #333 !important;\n        font-size: 14px !important;\n      }\n    }\n\n    /* 自定义 Checkbox 样式 */\n    :global {\n      .ant-checkbox-wrapper {\n        font-size: 14px;\n        color: #666;\n\n        .ant-checkbox-inner {\n          border-color: #d9d9d9 !important;\n        }\n\n        .ant-checkbox-checked .ant-checkbox-inner {\n          background-color: #79c9e3 !important;\n          border-color: #79c9e3 !important;\n        }\n      }\n    }\n  }\n\n  .shareBox {\n    display: flex;\n    gap: 50px;\n\n    .hideNameBox {\n      margin-right: 50px;\n    }\n  }\n}\n\n.bgColor {\n  border-radius: 4px;\n  background-color: #f8f8f8;\n}\n\n/* 第二个 Modal（链接分享）样式 */\n.linkModalContent {\n  margin-top: 30px;\n\n  .linkModalItem {\n    padding: 10px 15px;\n    border-radius: 4px;\n    background-color: #f8f8f8;\n\n    .label {\n      width: 80px; // 固定宽度，确保对齐\n      font-weight: 500;\n      color: #79c9e3;\n      margin-right: 8px;\n    }\n\n    .value {\n      flex: 1;\n      color: #333;\n      font-size: 14px;\n    }\n  }\n}\n\n/* 第三个 Modal（影像下载须知）样式 */\n.downloadModalContent {\n  margin-top: 20px;\n\n  .downloadInstructions {\n    margin-bottom: 16px;\n\n    p {\n      font-size: 14px;\n      color: #333; // 与 .section p 一致\n      line-height: 1.6;\n      margin-bottom: 8px;\n\n      span {\n        font-size: 15px;\n        color: #1a1a1a; // 突出显示“专业的浏览工具”\n        font-weight: 600;\n      }\n    }\n  }\n\n  .linkModalItem {\n    padding: 10px 15px;\n\n    .label {\n      width: 80px; // 固定宽度，确保对齐\n      font-weight: 500;\n      color: #79c9e3; // 与 linkModalContent 一致\n      margin-right: 8px;\n    }\n\n    .value {\n      flex: 1;\n      color: #333; // 与 linkModalContent 一致\n      font-size: 14px;\n    }\n  }\n}\n\n.downloadTip {\n  font-size: 14px;\n  color: #666; // 与 .disclaimer 一致\n  text-align: center;\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n/* 自定义 Modal 通用样式 */\n:global {\n  .ant-modal-header {\n    text-align: center;\n\n    .ant-modal-title {\n      font-size: 18px;\n      font-weight: 500;\n      color: #1a1a1a;\n    }\n  }\n\n  .ant-modal-footer {\n    border-top: none !important;\n    padding: 16px 0 !important;\n    text-align: center;\n    margin-top: 0;\n\n    .ant-btn-primary {\n      background-color: #79c9e3 !important; // 与页面主题色一致\n      border-color: #79c9e3 !important;\n      border-radius: 4px !important;\n      color: #fff !important;\n      transition: background-color 0.3s;\n\n      &:hover {\n        background-color: #5db9d8 !important; // 鼠标悬停时加深\n        border-color: #5db9d8 !important;\n      }\n    }\n  }\n\n  .ant-modal-close-x {\n    color: #666 !important;\n\n    &:hover {\n      color: #333 !important;\n    }\n  }\n\n  .ant-tabs-top>.ant-tabs-nav {\n    margin-bottom: 0 !important;\n  }\n}\n\n.customTabs {\n  .ant-tabs-tabpane {\n    display: block !important;\n    visibility: hidden;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-tabs-tabpane-active {\n    visibility: visible;\n    position: relative;\n  }\n}\n\n:global {\n  .ant-modal .ant-modal-footer>.ant-btn+.ant-btn {\n    margin-inline-start: 0 !important;\n  }\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWrap": `gwL_36s26zUU5lwPmPgL`,
	"container": `obN3YFDUFBVKq2X1TBYn`,
	"title": `XbK5WeDINyS2QyfLj0zq`,
	"content": `s7oBpiMqWc8mUEl9i1g2`,
	"customTabs": `A_sIGfyBmO23QNDucVfq`,
	"contentBoxMainWrap": `IAxDA1BZ5TPLKS8bvzD_`,
	"contentBoxMain": `L9uiZ1O_4aL0LuCgohJw`,
	"viewerBoxMain": `trfRUMKwkEsoEBOUW80n`,
	"contentBox": `MsISAq5Iu1BQxQkLTn0d`,
	"contentBoxTips": `xsUA8XwFNrtBlEUHxF7g`,
	"reportTitle": `XA4r2e4HlNgrIjCrBFmW`,
	"hospital": `chIP81EE8RII4Ti1GY_f`,
	"divider": `q4qWo7tRIP2JOwMHR2j8`,
	"infoSection": `LPr9m6y1XOZItM1oMzcA`,
	"infoItem": `XGet3iMXj0inrP56iU1A`,
	"label": `hTDPKvhmgqLoeKmM2DPJ`,
	"section": `G9NLV72Ui6HgyLEqiZ0c`,
	"sectionTitle": `iwkHR64fiJF1Bq7c1TnY`,
	"actionButtons": `rdrIudbR1foytG_1KbDt`,
	"actionItem": `P67Pbu2qAgoxoTe755Ct`,
	"filmPreview": `Hy1fX31IYOMJRN6mZSWV`,
	"filmImage": `t6CkAlHCz39Lkypg6_pL`,
	"downloadButton": `MreMBUEk6ultcTJYGRRq`,
	"historySection": `DxKFx6RLXkYyHID6p55c`,
	"historyIcon": `aep_mDXcqjhGoUx3PFf6`,
	"historyText": `Nn7JME_UjBj9A04Hx6Ig`,
	"historyArrow": `FKYW2JuEP2phXimzG378`,
	"disclaimer": `dIBhgdZQNb1Z9vhI9g0G`,
	"disclaimerTitle": `PTrs1mDcm6kZ7Gq_kX7y`,
	"shareModalContent": `WmjJ1A_qy4wmjaC3J_MI`,
	"shareModalItem": `DikjCWEiCDa25svx_SQp`,
	"modalSubtitle": `TwKzEOliy5w6hSEDg2_h`,
	"modalDesc": `dWUypglIC8T4iE0JK65B`,
	"shareBox": `wJrB6hEcmAgk7sssc02z`,
	"hideNameBox": `Ygddb044TA0PMdIWD7Rg`,
	"bgColor": `R5a8nVGXjuIUz7PY8suT`,
	"linkModalContent": `_cRxsD9BnwaEuSDkudTB`,
	"linkModalItem": `OfG95PD4W7NWYlVvlq_D`,
	"value": `OkEAY7RTDxU9xtS_ZZqp`,
	"downloadModalContent": `LUnxeDfm6tfYY1gA0BcE`,
	"downloadInstructions": `K9KbCzzITdY8mJIO68yi`,
	"downloadTip": `BgaAzY5XvXXGWCxBnqI8`,
	"ant-tabs-tabpane": `nwJU2OYzMoxH8TnsilXe`,
	"ant-tabs-tabpane-active": `rxNJ_89Crza76rEnnLJL`
};
export default ___CSS_LOADER_EXPORT___;
